import React, { useState, useEffect } from "react";
import "./RivalsInnInput.css";

function RivalsInnInput({ inn, name, rival, index, colour, deleteRival, handleRivalSelection }) {
  const [inputValue, setInputValue] = useState(inn || "");
  const [nameValue, setNameValue] = useState(name || "");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party";
  const DADATA_KEY = "7741279273200578f21c1616a4ea356fe2f857df";

  // Функция для получения подсказок с Dadata
  function handleNameInputChange(evt) {
    const query = evt.target.value;
    setNameValue(query); // Обновляем значение поля ввода названия компании

    if (query.trim() === "") {
      setSuggestions([]); // Если поле пустое, очищаем подсказки
      setShowSuggestions(false);
      return;
    }

    const options = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + DADATA_KEY,
      },
      body: JSON.stringify({ query: query, count: 10 }), // count - количество подсказок
    };

    fetch(url, options)
      .then((response) => response.json())
      .then((result) => {
        const suggestionsList = result.suggestions || [];
        setSuggestions(suggestionsList); // Сохраняем подсказки в состоянии
        setShowSuggestions(true); // Показываем список подсказок
      })
      .catch((error) => console.log("error", error));
  }

  // Функция для выбора подсказки
  // function selectSuggestion(suggestion) {
  //   setNameValue(suggestion.value); // Устанавливаем выбранное название компании
  //   setInputValue(suggestion.data.inn); // Устанавливаем ИНН компании
  //   setSuggestions([]); // Очищаем список подсказок
  //   setShowSuggestions(false); // Скрываем список подсказок
  // }

  function selectSuggestion(suggestion) {
    const inputElement = document.getElementById(`inputName_${index}`); // Получаем элемент поля ввода

    setNameValue(suggestion.value);
    setInputValue(suggestion.data.inn);
    setSuggestions([]);
    setShowSuggestions(false);
    handleRivalSelection(suggestion.data.inn);

    if (inputElement) {
      inputElement.focus();
    }
  }

  useEffect(() => {
    setInputValue(inn || "");
    setNameValue(name || "");
  }, [inn, name]);

  return (
    <div className="inputCard" id={`inputCard_${index}`}>
      <div className="inputCard__leftSide">
        <div
          className="inputCard__color"
          style={{ backgroundColor: colour }}
        ></div>
        <div className="inputCard__inputArea">
          <input
            type="text"
            className="inputCard__inputName"
            id={`inputName_${index}`}
            placeholder={name !== undefined ? `${name}` : "ВВЕДИТЕ НАЗВАНИЕ"}
            value={nameValue}
            onChange={handleNameInputChange}
          />
          {showSuggestions && (
            <div className="suggestionsListContainer">
              <ul className="suggestionsList">
                {suggestions.map((suggestion, idx) => (
                  <li
                    key={idx}
                    className="suggestionItem"
                    onClick={() => selectSuggestion(suggestion)}
                  >
                    <p className="suggestionAdress">{suggestion.value}</p>
                    <p className="suggestionAdress">ИНН: {suggestion.data.inn}</p>
                    <p className="suggestionAdress">{suggestion.data.address.value}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className="inputCard__2ndLine">
            <p className="inputCard__inputINN">{inputValue}</p>
            {(rival.staff !== undefined && rival.staff.length === 0) && <p className="inputCard__dataNotification">Нет численности</p>}
          </div>
        </div>
      </div>
      <div className="deleteBtn" onClick={deleteRival}></div>
    </div>
  );
}

export default RivalsInnInput;
